import Box from '@mui/material/Box'
import LinearProgress from '@mui/material/LinearProgress'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import { usePasswordStrength } from '../hooks/usePasswordStrength'

interface Props {
  password: string
}

const colorMap = {
  error: '#DC2626',
  warning: '#D97706',
  info: '#2563EB',
  success: '#16A34A',
}

export default function PasswordStrengthBar({ password }: Props) {
  const { t } = useTranslation('auth')
  const strength = usePasswordStrength(password)

  if (!password) return null

  return (
    <Box sx={{ mt: 0.75 }}>
      <LinearProgress
        variant="determinate"
        value={(strength.score / 4) * 100}
        sx={{
          height: 4,
          borderRadius: 2,
          bgcolor: '#E5E7EB',
          '& .MuiLinearProgress-bar': {
            bgcolor: colorMap[strength.color],
            borderRadius: 2,
            transition: 'all 0.3s ease',
          },
        }}
      />
      {strength.label && (
        <Typography
          variant="caption"
          sx={{ color: colorMap[strength.color], mt: 0.5, display: 'block' }}
        >
          {t('register.passwordStrength.prefix')}: {t(`register.passwordStrength.${strength.label}`)}
        </Typography>
      )}
    </Box>
  )
}
